/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/partials/tag.module.scss';

const propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: null,
    className: null,
};

const Tag = ({ label, color, className }) => (
    <div
        className={classNames([
            styles.container,
            { [className]: className !== null, [styles[color]]: color !== null },
        ])}
    >
        {label}
    </div>
);
Tag.propTypes = propTypes;
Tag.defaultProps = defaultProps;

export default Tag;
